import React, { useState } from 'react'
import '../../index.css'
import { useAppContext } from "../../Context";
import { FetchLogin } from '../../fetcher'
import { LoginView } from './LoginView';

/**
 * Component for handling the login process. 
 * Saves "username" and "password" in states and sets "userHasAuthenticated" if login fetch was successful
*/
const LoginContainer = () => {
    const { userHasAuthenticated } = useAppContext();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false)

    //checks the forms to enable/disable login
    function validateForm() {
        return username.length > 0 && password.length > 0;
    }

    //submits the login with data from view
    //sets error bool with a hook if login gets denied
    function handleSubmit(event) {
        event.preventDefault();
        setError(false)

        const loginData = {
            username, password
        }

        FetchLogin(userHasAuthenticated, loginData, setError)
    }

    return (
        <LoginView handleSubmit={handleSubmit} username={username} password={password} setUsername={setUsername} setPassword={setPassword} validateForm={validateForm} error={error} />
    )
}

export default (LoginContainer)